(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Transaction.Capture.Funding",
                {
                    url: "/Funding",
                    component: "captureFunding",
                    resolve: {
                        fundingSources: ["fundingSources", function (fundingSources) {
                            return fundingSources;
                        }],
                        taxQualifications: ["taxQualifications", function (taxQualifications) {
                            return taxQualifications;
                        }],
                        accountTypes: ["accountTypes", function (accountTypes) {
                            return accountTypes;
                        }],
                        fundsOriginationTypes: ["fundsOriginationTypes", function (fundsOriginationTypes) {
                            return fundsOriginationTypes;
                        }],
                        qualifiedRetirementAccountTypes: ["qualifiedRetirementAccountTypes", function (qualifiedRetirementAccountTypes) {
                            return qualifiedRetirementAccountTypes;
                        }],
                        fundsSpecificAccountOptions: ["fundsSpecificAccountOptions", function (fundsSpecificAccountOptions) {
                            return fundsSpecificAccountOptions;
                        }],
                        transactionFundingSources: ["transaction", "transactionFundingSourceApi", function (transaction,
                            transactionFundingSourceApi) {
                            return transactionFundingSourceApi.getFundingSourcesForTransaction(transaction.Id);
                        }],
                        prevStage: ["transaction", "transactionApi", "_", function (transaction, transactionApi, _) {
                            var currIndex = _.findIndex(transaction.CapturePoints,
                                function (capturePoint) {
                                    return capturePoint === "Funding";
                                });

                            if (currIndex === 0) {
                                transactionApi.getDisclosures(transaction.Id).then(function (disclosures) {
                                    return disclosures.length === 0 ? null : "Transaction.Disclose";
                                });
                            } else return "Transaction.Capture." + transaction.CapturePoints[currIndex - 1];
                        }],
                        nextStage: ["transaction", "_", function (transaction, _) {
                            var currIndex = _.findIndex(transaction.CapturePoints,
                                function (capturePoint) {
                                    return capturePoint === "Funding";
                                });

                            return currIndex === transaction.CapturePoints.length - 1
                                ? "Transaction.Determine.ProductChoice"
                                : "Transaction.Capture." + transaction.CapturePoints[currIndex + 1];
                        }]
                    },
                    onEnter: ["transactionApi", "transaction", function (transactionApi, transaction) {
                        transaction.LastTransactionStage = "Funding";
                        transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                    }]
                });
        }
    ]);

    app.component("captureFunding",
        {
            templateUrl: "/App/Transaction/Capture/Funding/template-funding.html",
            controller: captureFundingController,
            bindings: {
                transaction: "<",
                fundingSources: "<",
                taxQualifications: "<",
                accountTypes: "<",
                fundsOriginationTypes: "<",
                qualifiedRetirementAccountTypes: "<",
                fundsSpecificAccountOptions: "<",
                transactionFundingSources: "<",
                nextStage: "<",
                prevStage: "<"
            }
        });

    captureFundingController.$inject = ["$scope", "$state", "transactionFundingSourceApi", "_", "$mdDialog"];

    function captureFundingController($scope, $state, transactionFundingSourceApi, _, $mdDialog) {
        var $ctrl = this;
        $scope.$parent.$ctrl.getCurrentStage($state);
        $ctrl.durations = [
            { Label: "Over 6 Months", Value: true },
            { Label: "Under 6 Months", Value: false }
        ];
        $ctrl.chargesList = [
            { Label: "Yes", Value: true },
            { Label: "No", Value: false }
        ];
        $ctrl.chargesTypeList = [
            { Label: "%", Position: "switch-left", Value: true },
            { Label: "$", Position: "switch-right", Value: false }
        ];

        $ctrl.fullPartialList = [
            { Label: "Full", Value: false },
            { Label: "Partial", Value: true }
        ];
        //get last source to determine whether or not the add button will be disabled
        $ctrl.lastSource = $ctrl.transactionFundingSources[$ctrl.transactionFundingSources.length - 1];

        ng.extend($ctrl,
            {
                selection: {},
                addSource: addSource,
                setAllInactive: setAllInactive,
                createSource: createSource,
                selectType: selectType,
                checkSelectedWorkflow: checkSelectedWorkflow,
                remove: remove,
                setSelectedSource: setSelectedSource,
                save: save,
                resetWorkflow4: resetWorkflow4,
                setChargeType: setChargeType,
                selectSource: selectSource,
                maximizeNext: maximizeNext,
                maximizeNextCheckingWorkflow: maximizeNextCheckingWorkflow,
                getFirstUnanswered: getFirstUnanswered
            });

        //function refresh() {
        //    $ctrl.selectedSource;
        //    $ctrl.transactionFundingSources;
        //    $ctrl.class = $ctrl.selectedSource.FundingSource;
        //    debugger;
        //}


        function setAllInactive() {
            ng.forEach($ctrl.transactionFundingSources,
                function (row) {
                    return row.IsActive = false;
                });
        }

        function createSource(source) {
            $ctrl.selectedSource.TransactionId = $ctrl.transaction.Id;
            $ctrl.selectedSource.FundingSource = source.Value;
            var src = _.find($ctrl.fundingSources,
                function (row) { return row.Value === $ctrl.selectedSource.FundingSource; });
            if (src) {
                $ctrl.currentWorkflow = $ctrl.workflows[src.WorkflowId];
                $ctrl.maximized = 1;
            }
            return transactionFundingSourceApi.add($ctrl.selectedSource)
                .then(function (dbSource) {
                    $ctrl.selectedSource.AccountType = null;
                    $ctrl.selectedSource.Amount = null;
                    $ctrl.selectedSource.ChargeAmount = null;
                    $ctrl.selectedSource.ChargePercent = null;
                    $ctrl.selectedSource.FundsHeldOverSixMonths = null;
                    $ctrl.selectedSource.FundsOriginatingLocation = null;
                    $ctrl.selectedSource.FundsSpecificAccountOption = null;
                    $ctrl.selectedSource.HasMovingCharges = null;
                    $ctrl.selectedSource.IsPartialTransfer = null;
                    $ctrl.selectedSource.OriginationType = null;
                    $ctrl.selectedSource.OtherAccountType = null;
                    $ctrl.selectedSource.OtherFundingSource = null;
                    $ctrl.selectedSource.OtherQualifiedRetirementAccountType = null;
                    $ctrl.selectedSource.OtherTaxQualification = null;
                    $ctrl.selectedSource.PrimaryIsAdvisorOfRecord = null;
                    $ctrl.selectedSource.QualifiedRetirementAccountType = null;
                    $ctrl.selectedSource.TaxQualification = null;
                    return $ctrl.selectedSource.Id = dbSource.Id;
                });
        }

        function selectType(type, workflow) {
            if (type && workflow) {
                $ctrl.selection.TypeWorkflow = workflow;
                $ctrl.selection.FundingSource = type;
                debugger;
            }
        };

        function addSource() {
            var source = {};
            $ctrl.transactionFundingSources.push(source);
            $ctrl.selectedSource = source;
            $ctrl.lastSource = source;
            $ctrl.currentWorkflow = $ctrl.workflows[0];
            $ctrl.maximized = 0;
        }

        function checkSelectedWorkflow(workflowId) {
            if (!$ctrl.selectedSource.Id)
                return false;
            var src = _.find($ctrl.fundingSources,
                function (row) { return row.Value === $ctrl.selectedSource.FundingSource; });
            if (src && src.WorkflowId === workflowId)
                return true;
            return false;
        }

        function save() {
            var s = $ctrl.selectedSource;
            return transactionFundingSourceApi.update(s);
        }

        function remove(source, index, $event) {
            var sourceType = _.find($ctrl.fundingSources, function (row) { return row.Value === source.FundingSource; });
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to remove " + sourceType.Label + "?",
                targetEvent: $event,
                ariaLabel: "Confirm " + sourceType.Label + " removal",
                ok: "Yes",
                cancel: "No",
                skipHide: true,
                clickOutsideToClose: false
            });

            $mdDialog.show(confirm)
                .then(function () {
                    return transactionFundingSourceApi.remove($ctrl.transaction.Id, source.Id)
                        .then(function () {
                            $ctrl.transactionFundingSources.splice(index, 1);
                            return $ctrl.setSelectedSource();
                        });
                });
        }

        function selectSource(source) {
            $ctrl.selectedSource = source;
            if (!$ctrl.selectedSource.Id) {
                $ctrl.currentWorkflow = $ctrl.workflows[0];
                $ctrl.maximized = 0;
            }
            var src = _.find($ctrl.fundingSources,
                function (row) { return row.Value === $ctrl.selectedSource.FundingSource; });
            if (src) {
                $ctrl.currentWorkflow = $ctrl.workflows[src.WorkflowId];
                $ctrl.maximized = $ctrl.getFirstUnanswered($ctrl.selectedSource);
            }
        }

        // for reference
        $ctrl.questionKey = {
            0: { Question: "What type of account is this funding source?", Answer: "FundingSource" },
            1: { Question: "What is the amount of this funding source?", Answer: "Amount" },
            2: { Question: "What is the tax qualification of the account?", Answer: "TaxQualification", AnswerExplain: "OtherTaxQualification", ExplainNeededIf: "Other" },
            3: { Question: "Will this be a full or partial surrender?", Answer: "IsPartialTransfer" },
            4: { Question: "What charges are associated with moving these funds?", Answer: "HasMovingCharges", ExplainNeededIf: true, AnswerOneOfThese: ["ChargePercent", "ChargeAmount"] },
            5: { Question: "Was the primary agent on this transaction also the advisor of record for this account?", Answer: "PrimaryIsAdvisorOfRecord" },
            6: { Question: "How long have the funds been in the account?", Answer: "FundsHeldOverSixMonths" },
            7: { Question: "Please explain where these funds came from", Answer: "FundsOriginatingLocation", AdditionalAnswer: "TaxQualification", AdditionalAnswerExplain: "OtherTaxQualification", AdditionalAnswerExplainNeededIf: "Other" },
            8: { Question: "What type of account is it?", Answer: "AccountType", AnswerExplain: "OtherAccountType", ExplainNeededIf: "Other" },
            9: { Question: "Where did these funds originate?", Answer: "FundsOriginatingLocation" },
            10: { Question: "What type of account are funds coming from?", Answer: "QualifiedRetirementAccountType", AnswerExplain: "OtherQualifiedRetirementAccountType", ExplainNeededIf: "Other" },
            11: { Question: "Let's figure out if it is a rollover or transfer. Choose one.", Answer: "OriginationType" },
            12: { Question: "Please explain the type of funding source.", Answer: "OtherFundingSource" }
        }
        // all workflows contain questions 0 and 1
        $ctrl.workflows = [
            {},
            {
                Workflow: 1,
                Questions: [2, 4, 5]
            },
            {
                Workflow: 2,
                Questions: [2]
            },
            {
                Workflow: 3,
                Questions: [2, 3, 4, 5]
            },
            {
                Workflow: 4,
                Questions: [6, 7, 8, 9]
            },
            {
                Workflow: 5,
                Questions: [10, 11]
            },
            {
                Workflow: 6,
                Questions: [12, 2, 4]
            }
        ];

        function getFirstUnanswered(fundingSource) {
            if (!fundingSource.hasOwnProperty($ctrl.questionKey[1].Answer) || fundingSource.Amount === null) {
                return 1;
            }
            var src = _.find($ctrl.fundingSources,
                function (row) { return row.Value === fundingSource.FundingSource; });
            var workflow = $ctrl.workflows[src.WorkflowId];
            for (var questionKey in workflow.Questions) {
                if (workflow.Questions.hasOwnProperty(questionKey)) {

                    //special cases
                    
                    var question = workflow.Questions[questionKey];
                    var skip = false;
                    if (question === 7 && fundingSource.FundsHeldOverSixMonths === true) {
                        skip = true;
                    }
                    if (question === 8 && fundingSource.FundsHeldOverSixMonths === false) {
                        skip = true;
                    }
                    if (question === 9 &&
                    (fundingSource.FundsHeldOverSixMonths === false ||
                        fundingSource.AccountType === 'NonQualified')) {
                        skip = true;
                    }
                    //Check Question Is Answered
                    if (!skip) {
                        if (!fundingSource.hasOwnProperty($ctrl.questionKey[question].Answer) ||
                            fundingSource[$ctrl.questionKey[question].Answer] === null) {
                            return question;
                        }

                        //Check Answer Explanation
                        if ($ctrl.questionKey[question].AnswerExplain) {
                            if (fundingSource[$ctrl.questionKey[question].Answer] ===
                                $ctrl.questionKey[question].ExplainNeededIf &&
                                !fundingSource[$ctrl.questionKey[question].AnswerExplain]) {
                                return question;
                            }
                        }
                        //Check Additional Answer
                        if (fundingSource[$ctrl.questionKey[question].AdditionalAnswer] === null) {
                            return question;
                        }

                        //Check Additional Answer Explanation
                        if ($ctrl.questionKey[question].AdditionalAnswerExplain) {
                            if (fundingSource[$ctrl.questionKey[question].AdditionalAnswer] ===
                                $ctrl.questionKey[question].AdditionalAnswerExplainNeededIf &&
                                fundingSource[$ctrl.questionKey[question].AdditionalAnswerExplain] === null) {
                                return question;
                            }
                        }
                        //Check that one of these exists
                        if ($ctrl.questionKey[question].AnswerOneOfThese) {
                            if (fundingSource[$ctrl.questionKey[question].Answer] ===
                                $ctrl.questionKey[question].ExplainNeededIf &&
                                fundingSource[$ctrl.questionKey[question].AnswerOneOfThese[0]] === null &&
                                fundingSource[$ctrl.questionKey[question].AnswerOneOfThese[1]] === null) {
                                return question;
                            }
                        }
                    }
                }
            }
            return null;
        }

        function checkCompleteQuestions() {
            for (var fundingSourceKey in $ctrl.transactionFundingSources) {
                if ($ctrl.transactionFundingSources.hasOwnProperty(fundingSourceKey)) {
                    $ctrl.getFirstUnanswered($ctrl.transactionFundingSources[fundingSourceKey]) !== null
                        ? $ctrl.transactionFundingSources[fundingSourceKey].IsCompleted = false
                        : $ctrl.transactionFundingSources[fundingSourceKey].IsCompleted = true;
                }
            }
        }
        checkCompleteQuestions();

        function maximizeNext() {
            if ($ctrl.maximized === 1)
                $ctrl.maximized = $ctrl.currentWorkflow.Questions[0];
            else {
                $ctrl.getFirstUnanswered($ctrl.selectedSource) !== null
                    ? $ctrl.selectedSource.IsCompleted = false
                    : $ctrl.selectedSource.IsCompleted = true;

                var currentIndex = _.findIndex($ctrl.currentWorkflow.Questions, function (q) {
                    return q === $ctrl.maximized;
                });
                if (currentIndex === $ctrl.currentWorkflow.Questions.length - 1)
                    $ctrl.maximized = null;
                else
                    $ctrl.maximized = $ctrl.currentWorkflow.Questions[currentIndex + 1];
            }
        }

        function maximizeNextCheckingWorkflow() {
            $ctrl.getFirstUnanswered($ctrl.selectedSource) !== null
                ? $ctrl.selectedSource.IsCompleted = false
                : $ctrl.selectedSource.IsCompleted = true;
            if ($ctrl.maximized === 6) {
                if ($ctrl.selectedSource.FundsHeldOverSixMonths) {
                    $ctrl.maximized = 8;
                } else {
                    $ctrl.maximized = 7;
                }
            } else if ($ctrl.maximized === 7) {
                $ctrl.maximized = null;

            }
            else if ($ctrl.maximized === 8) {
                if ($ctrl.selectedSource.AccountType === 'Qualified' || $ctrl.selectedSource.AccountType === 'Other' && $ctrl.selectedSource.OtherAccountType)
                    $ctrl.maximized = 9;
                else
                    $ctrl.maximized = null;
            }
            else if ($ctrl.maximized === 9) {
                $ctrl.maximized = null;
            }
        }
        function resetWorkflow4() {
            var s = $ctrl.selectedSource;
            s.FundsOriginatingLocation = null;
            s.TaxQualification = null;
            s.OtherTaxQualification = null;
            s.AccountType = null;
            s.OtherAccountType = null;
        }

        function setSelectedSource() {
            if ($ctrl.transactionFundingSources.length === 0)
                $ctrl.addSource();
            else {
                $ctrl.selectedSource = $ctrl.transactionFundingSources[0];
                var src = _.find($ctrl.fundingSources,
                    function (row) { return row.Value === $ctrl.selectedSource.FundingSource; });
                if (src) {
                    $ctrl.currentWorkflow = $ctrl.workflows[src.WorkflowId];
                    $ctrl.maximized = $ctrl.getFirstUnanswered($ctrl.selectedSource);
                }
            }
        }
        setSelectedSource();

        function setChargeType() {
            $ctrl.chargeType = $ctrl.selectedSource.ChargeAmount
                ? $ctrl.chargesTypeList[1].Value
                : $ctrl.chargesTypeList[0].Value;
        }

        setChargeType();
    }
})(window.app, window.angular); //jshint ignore:line